module.exports = __webpack_public_path__ + "sidebar-bg.png?8b9b1d5b86901a9d0fb451b55c97e4ee";